import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const legalSections = [{
  title: 'Política de Privacidad',
  content: `En Misery Hats, protegemos tu información personal. Los datos que recopilamos durante el proceso de compra — nombre, dirección de envío, correo electrónico y datos de pago — se utilizan exclusivamente para procesar y entregar tu pedido. No compartimos, vendemos ni distribuimos tu información personal a terceros, salvo los servicios de mensajería necesarios para completar el envío. Toda la información se almacena de forma segura y se maneja conforme a las leyes de protección de datos aplicables. Al realizar una compra, aceptas el uso de tus datos según lo descrito en esta política.`
}, {
  title: 'Términos de Servicio',
  content: `Misery Hats es una marca de edición limitada. Cada diseño se produce en series exclusivas de 100 piezas numeradas. Una vez agotado el inventario, el diseño se retira permanentemente de producción. Al realizar una compra, aceptas que estás adquiriendo una pieza de colección sujeta a disponibilidad. Los precios, diseños y disponibilidad pueden cambiar sin previo aviso. Misery Hats se reserva el derecho de cancelar pedidos en caso de error en el precio o disponibilidad. El uso de este sitio web implica la aceptación de estos términos.`
}, {
  title: 'Envíos y Devoluciones',
  content: `Debido a la naturaleza limitada de nuestros drops (1/100 piezas), todas las ventas son finales. Cada gorra es inspeccionada en calidad antes del envío. El tiempo de envío es de 2 a 5 días hábiles después de procesada la orden. Si recibes un producto con defecto de fabricación, contáctanos dentro de las primeras 48 horas posteriores a la recepción para evaluar tu caso. Misery Hats no se hace responsable por retrasos causados por el servicio de mensajería una vez que el paquete ha sido despachado.`
}];
export function LegalFooter() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-black border-t border-gray-800 py-12 md:py-16 px-4" data-id="element-44">
      <div className="max-w-3xl mx-auto" data-id="element-45">
        <h3 className="font-bebas text-2xl md:text-3xl text-misery-magenta text-center mb-8 tracking-wider" data-id="element-46">
          LEGAL
        </h3>

        <div className="space-y-3" data-id="element-47">
          {legalSections.map((section, index) => <div key={index} className="border border-gray-800" data-id="element-48">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 md:p-5 text-left hover:bg-gray-900/50 transition-colors" data-id="element-49">
                <span className="font-inter text-white font-medium text-sm md:text-base" data-id="element-50">
                  {section.title}
                </span>
                <ChevronDown className={`w-4 h-4 text-misery-magenta transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-51" />
              </button>
              <AnimatePresence data-id="element-52">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-53">
                    <p className="px-4 md:px-5 pb-5 font-inter text-gray-400 text-sm leading-relaxed" data-id="element-54">
                      {section.content}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        <p className="text-center text-gray-600 font-inter text-xs mt-8" data-id="element-55">
          © 2026 Misery Hats. Todos los derechos reservados.
        </p>
      </div>
    </section>;
}